import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetIssueTaskItemsDto, queryKeys, useAccessToken } from "src/http";

const useGetIssueTaskItemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getIssueTaskItemsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getIssueTaskItems>>): Promise<GetIssueTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [{ issueGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/issues/${issueGuid}/task-items`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getIssueTaskItemsRequest };
};

const useGetIssueTaskItems = (issueGuid: string | undefined) => {
  const { getIssueTaskItemsRequest } = useGetIssueTaskItemsRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getIssueTaskItems(issueGuid),
    queryFn: getIssueTaskItemsRequest,
    enabled: issueGuid !== undefined,
  });
};

export { useGetIssueTaskItems };
